import { call, put, takeLatest } from 'redux-saga/effects';
import HeroAccountAPI from 'api-services/HeroAccountApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { logout } from '../auth/actionCreators';
import { checkUserHelper } from '../utils/helperSagas';
import { GET_CAREGIVERS } from './actionTypes';
import { getCaregiversDone, getCaregiversError } from './actionCreators';
export function* getCaregivers(constAccessParams) {
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroAccountAPI.getCaregivers, newAccessParams);
    if (isSuccessResponse(result)) {
        yield put(getCaregiversDone(result.data));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(getCaregiversError(result.msg));
    }
}
export function* watchGetCaregiversCalls(constAccessParams) {
    yield takeLatest(GET_CAREGIVERS, getCaregivers, constAccessParams);
}
//# sourceMappingURL=saga.js.map